import { Search, ShieldCheck, MessageSquare, Zap, Target, BarChart2 } from 'lucide-react';

const NAV = [
  { id: 'hunt', icon: Search, label: 'Hunt' },
  { id: 'qualify', icon: ShieldCheck, label: 'Qualify' },
  { id: 'pitches', icon: MessageSquare, label: 'Scripts' },
  { id: 'ai', icon: Zap, label: 'AI Pitch' },
  { id: 'tracker', icon: Target, label: 'Tracker' },
  { id: 'analytics', icon: BarChart2, label: 'Stats' },
];

export default function BottomNav({ active, setActive }) {
  return (
    <nav style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 100,
      background: 'var(--bg2)', borderTop: '1px solid var(--border)',
      display: 'flex', alignItems: 'center',
      paddingBottom: 'env(safe-area-inset-bottom)',
    }}>
      {NAV.map(({ id, icon: Icon, label }) => {
        const isActive = active === id;
        return (
          <button key={id} onClick={() => setActive(id)} style={{
            flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', gap: 3, padding: '8px 4px',
            background: 'none', border: 'none', cursor: 'pointer',
            color: isActive ? 'var(--accent)' : 'var(--text3)',
            transition: 'color 0.15s',
          }}>
            <Icon size={18} />
            <span style={{ fontSize: 9, fontFamily: 'var(--font-mono)', letterSpacing: '0.03em' }}>{label}</span>
            {isActive && (
              <div style={{ width: 3, height: 3, borderRadius: '50%', background: 'var(--accent)', marginTop: 1 }} />
            )}
          </button>
        );
      })}
    </nav>
  );
}